/* eslint-disable */
import { produce } from "immer";
import {
  BENEFICIARY_POST_FETCH_FAILURE,
  BENEFICIARY_POST_FETCH_SUCCESS,
  BENEFICIARY_POST_FETCH_START,
} from "../actions/types";

const submitBeneficiaries = (
  state = {
    beneficiaryPostFetching: false,
    beneficiaryPostData: [],
    beneficiaryPostError: null,
  },
  action,
) => {
  switch (action.type) {
    case BENEFICIARY_POST_FETCH_START:
      return produce(state, (draft) => {
        draft.beneficiaryPostFetching = true;
      });
    case BENEFICIARY_POST_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.beneficiaryPostFetching = true;
        draft.beneficiaryPostData = action.data;
        draft.beneficiaryPostFetching = false;
      });
    case BENEFICIARY_POST_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.beneficiaryPostFetching = false;
        draft.beneficiaryPostError = action.error;
      });
    default:
      return state;
  }
};

export default submitBeneficiaries;
